import {
    LOADING_TOGGLE_ACTION,
    GET_BRANCHES_SUCCESS,
    GET_BRANCHES_FAILED,
    GET_BRANCH_BY_ID_SUCCESS,
    GET_BRANCH_BY_ID_FAILED,
    CREATE_BRANCH_SUCCESS,
    CREATE_BRANCH_FAILED,
    UPDATE_BRANCH_SUCCESS,
    UPDATE_BRANCH_FAILED,
    DELETE_BRANCH_SUCCESS,
    DELETE_BRANCH_FAILED,
    GET_BRANCHES_FOR_SELECT_SUCCESS,
    CLEAR_CURRENT_BRANCH,
    CLEAR_ERRORS
} from '../actions/BranchesActions';

const initialState = {
    listdata: [],
    data: {},
    pagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 1,
        currentPage: 1,
        totalItems: 0,
        itemsPerPage: 10,
        hasNextPage: false,
        hasPreviousPage: false
    },
    loading: false,
    error: null,
    success: null
};

export function BranchesReducer(state = initialState, action) {
    switch (action.type) {
        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                loading: action.payload,
                error: action.payload ? null : state.error
            };

        case GET_BRANCHES_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: action.payload.data || [],
                pagination: {
                    ...state.pagination,
                    ...action.payload.pagination,
                },
                error: null,
            };

        case GET_BRANCHES_FAILED:
            return {
                ...state,
                loading: false,
                listdata: [],
                error: action.payload
            };

        case GET_BRANCH_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };

        case GET_BRANCH_BY_ID_FAILED:
            return {
                ...state,
                loading: false,
                data: {},
                error: action.payload
            };

        case CREATE_BRANCH_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: [action.payload, ...state.listdata],
                data: action.payload,
                error: null,
                success: "Branch created successfully"
            };

        case CREATE_BRANCH_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: null
            };

        case UPDATE_BRANCH_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: state.listdata.map(branch =>
                    branch.id === action.payload.id
                        ? { ...branch, ...action.payload }
                        : branch
                ),
                data: action.payload,
                error: null,
                success: "Branch updated successfully"
            };

        case UPDATE_BRANCH_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: null
            };

        case DELETE_BRANCH_SUCCESS:
            return {
                ...state,
                loading: false,
                listdata: state.listdata.filter(branch => branch.id !== action.payload),
                error: null,
                success: "Branch deleted successfully"
            };

        case DELETE_BRANCH_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: null
            };

        case GET_BRANCHES_FOR_SELECT_SUCCESS:
            return {
                ...state,
                branchesForSelect: action.payload,
                error: null
            };

        case CLEAR_CURRENT_BRANCH:
            return {
                ...state,
                data: {},
                error: null,
            };

        case CLEAR_ERRORS:
            return {
                ...state,
                error: null,
                success: null
            };

        default:
            return state;
    }
}

export default BranchesReducer;